// 菜单
export const menus = {
  // 合伙人
  partner: [
    {
      label: '首页',
      name: 'home'
    }, {
      label: '公司列表',
      name: 'companyList'
    }, {
      label: '保单列表',
      name: 'insuranceList'
    }, {
      label: '收益统计',
      name: 'earningsStatisticsPartner'
    }
  ],
  // 商家
  business: [
    {
      label: '首页',
      name: 'home'
    }, {
      label: '公司信息',
      name: 'companyList'
    }, {
      label: '保险保单',
      name: 'insuranceList'
    }/* , {
      label: '购买保险',
      name: 'buyInsurance'
    }, {
      label: '历史保单',
      name: 'insuranceList'
    } */
  ],
  // 管理员
  total: [
    {
      label: '首页',
      name: 'home'
    }, {
      label: '合伙人',
      name: 'partner'
    }, {
      label: '公司列表',
      name: 'companyList'
    }, {
      label: '产品设置',
      name: 'product'
    }, {
      label: '保单列表',
      name: 'insuranceListTotal'
    }, {
      label: '发票审核',
      name: 'auditInvoice'
    }, {
      label: '收益统计',
      name: 'earningsStatistics'
    }
  ]
}

// 按钮权限
export const button = {
  // 合伙人
  partner: [],
  // 商家
  business: ['addInsurance'],
  total: []
}